import React from 'react';
import { CheckCircle2, Phone } from 'lucide-react';
const PHONE = '586-203-3701';
export function ShingleFocus() {
  return <section className="bg-white py-20 sm:py-24" data-id="element-291" data-mp="3dt0kh2xv2gud">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-292" data-mp="3rtl05q8hbwjn">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-293" data-mp="3rss4plez0tgt">
          {/* Image */}
          <div className="relative" data-id="element-294" data-mp="3mv9rhitx7s30">
            <img src="https://cdn.magicpatterns.com/uploads/i1Y2DSyZWn6zHA8rZ9u5rN/roof-replacement.jpg" alt="Completed Moceri shingle roof replacement on a Michigan home — drone view showing new architectural shingles with Moceri Roofing service van" className="w-full h-[420px] sm:h-[520px] object-cover rounded-2xl shadow-xl" data-id="element-295" data-mp="2z4mi0t4cwuec" />
            <div className="absolute -bottom-6 -right-6 hidden md:flex flex-col bg-[#2DB8E0] text-white px-6 py-4 rounded-xl shadow-lg" data-id="element-296" data-mp="3425z00sfvl9z">
              <span className="font-display italic text-3xl leading-none" data-id="element-297" data-mp="2bg39ccheaflq">
                25+
              </span>
              <span className="text-sm font-semibold uppercase tracking-wide mt-1" data-id="element-298" data-mp="2c5aupofvswxp">
                Years roofing
                <br data-id="element-299" data-mp="2h3cbg2pu4k60" />
                Michigan homes
              </span>
            </div>
          </div>

          {/* Copy */}
          <div data-id="element-300" data-mp="2qv094lczixfx">
            <span className="inline-block text-[#2DB8E0] font-bold uppercase tracking-wider text-sm mb-4" data-id="element-301" data-mp="2quqegkgzw23w">
              Shingle Roof Replacement
            </span>
            <h2 className="font-display italic text-4xl sm:text-5xl text-[#1a2332] leading-tight mb-6" data-id="element-302" data-mp="1t9cdi2ocsj5g">
              Built for Michigan. Backed by Quality.
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-6" data-id="element-303" data-mp="234maud3t42cw">
              Michigan winters are brutal on shingle roofs. Ice dams,
              freeze-thaw cycles, and heavy snow loads can take years off a
              poorly-installed roof. We use premium architectural shingles rated
              for Michigan's extreme weather — installed by a crew that's been
              doing this for decades.
            </p>

            <ul className="space-y-3 mb-8" data-id="element-304" data-mp="1jj8yporkee5n">
              {['Complete tear-off of old roofing materials', 'Decking inspection & repair where needed', 'Premium ice & water shield protection', 'Architectural shingles — 25 to 50 year lifetime warranties', 'Proper ventilation & ridge cap installation', 'Full cleanup with magnetic nail sweep'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-305" data-mp="vteoleymr3p3">
                  <CheckCircle2 className="w-6 h-6 text-[#2DB8E0] flex-shrink-0 mt-0.5" data-id="element-306" data-mp="19ji13e7pjj1c" />
                  <span className="text-slate-700 font-medium" data-id="element-307" data-mp="14s01oulc1qih">{item}</span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-308" data-mp="h1mhtrcwixyz">
              <a href="#quote-form" className="inline-flex items-center justify-center bg-[#2DB8E0] hover:bg-[#1a9cc4] text-white font-bold px-7 py-4 rounded-full transition-all shadow-md hover:shadow-lg" data-id="element-309" data-mp="c4e01rvo0vy9">
                <span className="mr-2" data-id="element-310" data-mp="2sj7lmokqjc7g">—</span>
                Get a Quote Now!
                <span className="ml-2" data-id="element-311" data-mp="2ersyq6npiqv4">—</span>
              </a>
              <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center justify-center gap-2 border-2 border-[#1a2332] text-[#1a2332] hover:bg-[#1a2332] hover:text-white font-bold px-6 py-4 rounded-full transition-colors" data-id="element-312" data-mp="2jp2yog8q2kx7">
                <Phone className="w-5 h-5" data-id="element-313" data-mp="2xh9dnz052lv2" /> {PHONE}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}